import { useState } from "react";
import { useSelector } from "react-redux";

import Posts from "./RefundHistoryTable";
import Pagination from "../../../StyledComponents/Pagination";
import { BillingFooter, BillingFooterSpacer } from "../styles";

const RefundHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const refundList = useSelector((state) => state.Refund?.RefundList || []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = refundList.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(refundList.length / postsPerPage);

  return (
    <>
      <Posts RefundLists={currentPosts} />
      <BillingFooter>
        {currentPosts.length !== 0 && howManyPages > 1 ? (
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        ) : (
          <BillingFooterSpacer />
        )}
      </BillingFooter>
    </>
  );
};

export default RefundHistory;
